import { render, staticRenderFns } from "./FreelanceCreateTask.vue?vue&type=template&id=3fb4566f&scoped=true&"
import script from "./FreelanceCreateTask.vue?vue&type=script&lang=js&"
export * from "./FreelanceCreateTask.vue?vue&type=script&lang=js&"
import style0 from "./FreelanceCreateTask.vue?vue&type=style&index=0&id=3fb4566f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb4566f",
  null
  
)

export default component.exports